import { useEffect } from "react";

export default function LogoutHelper() {
  useEffect(() => {
    window.addEventListener("message", (event) => {
      if (event.origin !== "https://visajobsuk.com") return;

      if (event.data === "logout") {
        localStorage.removeItem("authToken");
        console.log("Auth token removed from React localStorage");
      }
    });
  }, []);

  return <div>Logout helper loaded...</div>;
}
